import { TripMonthType } from 'app/constants/configuration/tripMonthType'

export const getTripMonthTypeName = (
  tripMonthType: TripMonthType,
  translate: (string) => string,
): string => {
  const text: string = TripMonthType[tripMonthType]
  return translate(`tripMonthType.${text}`)
}
